'use client';
import { createContext, useContext } from 'react';
export const I18nContext = createContext(null);
export const getI18nContext = () => {
    globalThis['@ui5/webcomponents-react'] ??= {};
    globalThis['@ui5/webcomponents-react'].I18nContext ??= I18nContext;
    return globalThis['@ui5/webcomponents-react'].I18nContext;
};
export const useI18nContext = () => useContext(getI18nContext());
